import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { isKreedalabsUser } from "../../utils/isKreedalabsUser";

interface KreedalabsInternalRouteProps {
  roles: string[];
  element: React.ReactElement;
}

const KreedalabsInternalRoute: React.FC<KreedalabsInternalRouteProps> = ({
  roles,
  element,
}) => {
  const user = useSelector((state: RootState) => state.user.userInfo);

  if (!user) {
    return <Navigate to="/auth/login" />;
  }

  if (!roles.includes(user.group) || !isKreedalabsUser(user.email)) {
    return <Navigate to="/" />;
  }

  return element;
};

export default KreedalabsInternalRoute;
